/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type TrustpilotWidgetApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
}

/* Schemas */
export const TrustpilotWidgetApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
})

/* Schemas validation */
type TestTrustpilotWidgetProps = ExpectTrue<
  Equal<
    TrustpilotWidgetApiProps,
    z.infer<typeof TrustpilotWidgetApiPropsSchema>
  >
>
